export const style = {
  iframe: {
    width: '100%',
    flex: 1,
    border: 0,
    backgroundColor: '#FFFFFF',
  },
};
